var _mask, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivePlanVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_6250_6763",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H54C60.6274 0 66 5.37258 66 12V54C66 60.6274 60.6274 66 54 66H12C5.37258 66 0 60.6274 0 54V12Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H54C60.6274 0 66 5.37258 66 12V54C66 60.6274 60.6274 66 54 66H12C5.37258 66 0 60.6274 0 54V12Z",
    fill: "url(#paint0_linear_6250_6763)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0V2.0625H54V0V-2.0625H12V0ZM66 12H63.9375V54H66H68.0625V12H66ZM54 66V63.9375H12V66V68.0625H54V66ZM0 54H2.0625V12H0H-2.0625V54H0ZM12 66V63.9375C6.51167 63.9375 2.0625 59.4883 2.0625 54H0H-2.0625C-2.0625 61.7665 4.2335 68.0625 12 68.0625V66ZM66 54H63.9375C63.9375 59.4883 59.4883 63.9375 54 63.9375V66V68.0625C61.7665 68.0625 68.0625 61.7665 68.0625 54H66ZM54 0V2.0625C59.4883 2.0625 63.9375 6.51167 63.9375 12H66H68.0625C68.0625 4.2335 61.7665 -2.0625 54 -2.0625V0ZM12 0V-2.0625C4.2335 -2.0625 -2.0625 4.2335 -2.0625 12H0H2.0625C2.0625 6.51167 6.51167 2.0625 12 2.0625V0Z",
    fill: "#AD46FF",
    fillOpacity: 0.3,
    mask: "url(#path-1-inside-1_6250_6763)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4159 21.3549C32.4735 21.2504 32.558 21.1632 32.6607 21.1025C32.7635 21.0418 32.8806 21.0098 32.9999 21.0098C33.1192 21.0098 33.2364 21.0418 33.3391 21.1025C33.4418 21.1632 33.5264 21.2504 33.5839 21.3549L37.5199 28.8269C37.6138 28.9999 37.7448 29.15 37.9035 29.2664C38.0623 29.3828 38.2448 29.4626 38.438 29.5C38.6313 29.5375 38.8304 29.5317 39.0212 29.4831C39.2119 29.4345 39.3895 29.3443 39.5412 29.2189L45.2439 24.3336C45.3534 24.2445 45.4883 24.1925 45.6292 24.185C45.7701 24.1775 45.9098 24.215 46.028 24.2919C46.1463 24.3688 46.2372 24.4813 46.2875 24.6131C46.3377 24.745 46.3449 24.8894 46.3079 25.0256L42.5292 38.6869C42.4521 38.9664 42.2859 39.2132 42.0559 39.3898C41.8259 39.5664 41.5446 39.6632 41.2546 39.6656H24.7466C24.4564 39.6635 24.1747 39.5669 23.9444 39.3902C23.7141 39.2136 23.5478 38.9667 23.4706 38.6869L19.6932 25.0269C19.6562 24.8907 19.6634 24.7463 19.7137 24.6145C19.764 24.4826 19.8548 24.3702 19.9731 24.2932C20.0914 24.2163 20.2311 24.1789 20.372 24.1864C20.5129 24.1938 20.6478 24.2459 20.7572 24.3349L26.4586 29.2202C26.6103 29.3456 26.7879 29.4359 26.9787 29.4845C27.1694 29.5331 27.3685 29.5388 27.5618 29.5014C27.755 29.4639 27.9376 29.3841 28.0963 29.2677C28.255 29.1513 28.3861 29.0012 28.4799 28.8282L32.4159 21.3549Z",
    stroke: "#DAB2FF",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6665 45H42.3332",
    stroke: "#DAB2FF",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6250_6763",
    x1: 0,
    y1: 0,
    x2: 66,
    y2: 66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9810FA",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#155DFC",
    stopOpacity: 0.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivePlanVector);
export default __webpack_public_path__ + "static/media/ActivePlanVector.c10ccae5b5adf0bb88839462037a6472.svg";
export { ForwardRef as ReactComponent };